import { useEffect } from "@wordpress/element";
import { useSelector, useDispatch } from "react-redux";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import queryString from "query-string";
import { Button } from "vino/core";
import { getFrequencyText } from "utils";
import { getWineClub } from "store/vino/wineClubsSlice";

const WineClub = ({ onNext }) => {
	const dispatch = useDispatch();
	const wineClub = useSelector(({ vino }) => vino.wineClubs.data);

	const parsed = queryString.parse(location.search);
	const { clubId } = parsed;

	useEffect(() => {
		if (clubId) {
			dispatch(getWineClub(clubId));
		}
	}, [dispatch, clubId]);

	if (!wineClub) {
		return null;
	}

	return (
		<Paper className="w-full rounded-20 shadow flex flex-wrap">
			<div className="flex-1 w-3/5">
				<div className="flex flex-col w-full">
					<div className="flex items-center p-20">
						<Typography className="text-16 font-medium">
							Subscription
						</Typography>
					</div>
					<div className="w-full px-20">
						<div className="mb-5">
							<Typography>
								<span className="text-14 font-medium">{wineClub.name}</span>
							</Typography>
						</div>
						<div className="mb-5">
							<Typography className="mb-5">
								<span className="text-12">{wineClub.description}</span>
							</Typography>
						</div>
						<div className="mb-20">
							<Typography>
								<span>
									Receive a curated selection of {wineClub.bottles} bottles,
									{getFrequencyText(wineClub.frequency)}
								</span>
							</Typography>
						</div>
					</div>
					<Divider className="my-10" />
					<div className="w-full p-20 mt-20">
						<div className="flex justify-end">
							<Button type="button" onClick={onNext}>
								Next
							</Button>
						</div>
					</div>
				</div>
			</div>
		</Paper>
	);
};

export default WineClub;
